module.exports = __webpack_public_path__ + "img/lighthouse-rafiki.48dd8d00.svg";